import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DetailConfigurationField} from "../../../models/detail-configuration-field";
import {HelperService} from "../../../services/helperService";
import {SharedDataService} from "../../../services/shared/shared-data.service";
import {DetailService} from "../../../services/details/detail.service";
import {Subscription} from "rxjs/internal/Subscription";
import {forkJoin} from "rxjs";
import {ContentsHelper} from "../../../helpers/contents.helper";
import {FormGroup} from "@angular/forms";

@Component({
	selector: 'tig-tabs-publicationobjects',
	templateUrl: './tabs-publicationobjects.component.html',
	styleUrls: ['./tabs-publicationobjects.component.scss']
})
export class TabsPublicationobjectsComponent implements OnInit, OnDestroy
{

	/**
	 * Attributes
	 */
	@Input()
	OBJ_field_config: DetailConfigurationField;
	@Input()
	ARR_fields: DetailConfigurationField[];
	@Input()
	OBJ_parent_form_group: FormGroup;
	@Input()
	STR_form_group_name: string;
	private ARR_subscriptions: Subscription[] = [Subscription.EMPTY];
	private MAP_filled_dependecies = new Map();
	private INT_dependecies = 0;
	private ARR_content_helpers: Array<ContentsHelper> = [];


	constructor(public OBJ_helper_service: HelperService, private OBJ_shared_Service: SharedDataService, private OBJ_detail_service: DetailService)
	{}

	ngOnInit()
	{

		// get already reloaded dropdown-options from detail service
		this.ARR_content_helpers = this.OBJ_detail_service.getReloadedData();

		if (DetailService.externalCompositionHasDependency(this.OBJ_field_config))
		{
			// Hole letzten Eintrag in der dependecy-Kette
			let STR_last_key = Object.keys(this.OBJ_field_config._links.composition.depends_on).pop();

			Object.keys(this.OBJ_field_config._links.composition.depends_on).forEach(STR_placeholder => {
				this.INT_dependecies++;
				let STR_dependency_name = this.OBJ_field_config._links.composition.depends_on[STR_placeholder];

				// find field in which necessary data is stored
				let OBJ_parent_field = this.ARR_fields.find(OBJ_field => OBJ_field.name === STR_dependency_name);

				// has this field a value?
				if(OBJ_parent_field.value)
				{
					// in this case add value to map of dependencies
					this.MAP_filled_dependecies.set(STR_placeholder, OBJ_parent_field.value);

				} // end if

				// Hoere auf Wertaenderung des "Elternfeldes"
				this.ARR_subscriptions.push(this.OBJ_shared_Service.getValue(STR_dependency_name).subscribe(
					MIX_changed_value => {

						// reset fields
						this.OBJ_field_config.fields = [];

						// Elternelement hat neuen Wert
						if (MIX_changed_value)
						{
							this.MAP_filled_dependecies.set(STR_placeholder, MIX_changed_value);

						}
						// Wert des Elternelementes wurde zurueckgesetzt
						else
						{
							this.MAP_filled_dependecies.delete(STR_placeholder)
						} // end if

						// Alle Elternfelder sind ausgefuellt, nun kann Inhalt nachgeladen werden
						// Nachladen nur antriggern, wenn sich wirklich die letzte Dependecy geaendert hat
						if (STR_last_key === STR_placeholder && this.MAP_filled_dependecies.size === this.INT_dependecies)
						{

							// Get url to reload the selected composition
							let STR_reload_url =  this.OBJ_field_config._links.composition.href;

							// url is dependent on value of parent fields - fill in this dependency
							this.MAP_filled_dependecies.forEach(
								(MIX_value, STR_dependency_key) =>
								{
									STR_reload_url = STR_reload_url.replace(STR_dependency_key, MIX_value);
								}
							); // end forEach

							// Dropdowns nachladen
							this.OBJ_detail_service.getHelper(STR_reload_url, null, 'TabsPublicationobjectsComponent parent changes').subscribe(
								OBJ_contents_helper => {
									let ARR_publicationobjects = OBJ_contents_helper.getValue('publicationobjects');

									if(ARR_publicationobjects.length > 0)
									{
										this.OBJ_detail_service.createArrayFields(ARR_publicationobjects, this.OBJ_field_config);

										// Dropdowns befuellen
										for (let OBJ_publicationobject of this.OBJ_field_config.fields)
										{
											this.OBJ_detail_service.fillExternalOptions(OBJ_publicationobject, this.ARR_content_helpers);

										} // end for

									} // end if

								}); // end subscribe

						} // end if

					} // end subscribe
				));

			}); // end foreach

		} // end if

	} // end function ngOnInit

	ngOnDestroy(): void
	{
		// Unsubscribe from all subscriptions to prevent memory leak
		this.ARR_subscriptions.forEach(
			(OBJ_subscription: Subscription) => {
				OBJ_subscription.unsubscribe();
			}
		);
	} // end function ngOnDestroy

}
